// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3SeKJ","rootCenter":"LoadMoreObserver_rootCenter__2qqNG","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2JZ9G"};